import { Injectable, signal } from '@angular/core';
import { apiErrorMessage } from './api-error';

export interface Toast {
  id: number;
  message: string;
  kind: 'ok' | 'err';
}

/** Un error suele traer causa y qué hacer: necesita más tiempo de lectura que un "listo". */
const DURATION_MS = { ok: 4000, err: 9000 } as const;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private seq = 0;
  readonly toasts = signal<Toast[]>([]);

  success(message: string) {
    this.push(message, 'ok');
  }

  error(message: string) {
    this.push(message, 'err');
  }

  /**
   * Muestra el error de una llamada HTTP: el texto del backend si lo mandó, o `fallback`
   * (qué falló) más la causa según el status. Nunca muestra "Http failure response…".
   */
  apiError(err: unknown, fallback: string) {
    this.push(apiErrorMessage(err, fallback), 'err');
  }

  private push(message: string, kind: 'ok' | 'err') {
    const id = ++this.seq;
    this.toasts.update((list) => [...list, { id, message, kind }]);
    setTimeout(() => this.dismiss(id), DURATION_MS[kind]);
  }

  dismiss(id: number) {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }
}
